import firebase from 'firebase'
const config = {
  apiKey: "AIzaSyBD5ML-QmRK1d-gr9lxn1-Na7nB7_QFdow",
  authDomain: "incart-27adb.firebaseapp.com",
  databaseURL: "https://incart-27adb.firebaseio.com",
  storageBucket: "incart-27adb.appspot.com",
  projectId: "incart-27adb"
}

firebase.initializeApp(config)

export const fireBaseAuth = firebase.auth
export const firebaseStorage = firebase.storage
export const fireBaseDatabase = firebase.database


// WEBPACK FOOTER //
// ./src/firebase/config.js